enum AlertType {
    INFO = 'info',
    PRIMARY = 'primary',
    SECONDARY='secondary',
    WARNING = 'warning',
    DANGER = 'danger',
    SUCCESS = 'success',
}

export default AlertType;